(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/ApiDocAdminModQueryResp', '../model/AdminModRequest', '../model/ApiDocStringList'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ApiDocAdminModQueryResp'), require('../model/AdminModRequest'), require('../model/ApiDocStringList'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.AdminadminportalmodApi = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.ApiDocAdminModQueryResp, root.SmartCsV2Sdk.AdminModRequest, root.SmartCsV2Sdk.ApiDocStringList);
  }
}(this, function(ApiClient, ApiDocAdminModQueryResp, AdminModRequest, ApiDocStringList) {
  'use strict';

  /**
   * Adminadminportalmod service.
   * @module api/AdminadminportalmodApi
   * @version 2.0.624
   */

  /**
   * Constructs a new AdminadminportalmodApi. 
   * @alias module:api/AdminadminportalmodApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getModInfo operation.
     * @callback module:api/AdminadminportalmodApi~getModInfoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApiDocAdminModQueryResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Content Mod info
     * &lt;p&gt;\n\n Admin and Platform specific scope required &lt;/br&gt;\n\n contentIds and status cannot be used at the same time. If both are present, contentIds will be used.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.contentIds coma(,) delimited contentIds (no space around the coma)
     * @param {module:model/String} opts.status mod status
     * @param {Array.<String>} opts.resourceType 
     * @param {Integer} opts.limit Number of data to be returned
     * @param {String} opts.nextPageToken Token for retrieving next batch of data
     * @param {module:model/String} opts.sortBy 
     * @param {module:api/AdminadminportalmodApi~getModInfoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ApiDocAdminModQueryResp}
     */
    this.getModInfo = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'contentIds': this.apiClient.buildCollectionParam(opts['contentIds'], 'csv'),
        'status': opts['status'],
        'resourceType': this.apiClient.buildCollectionParam(opts['resourceType'], 'csv'),
        'limit': opts['limit'],
        'nextPageToken': opts['nextPageToken'],
        'sortBy': opts['sortBy']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ApiDocAdminModQueryResp;

      return this.apiClient.callApi(
        '/admin/admin_portal/mod', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the putContentMod operation.
     * @callback module:api/AdminadminportalmodApi~putContentModCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApiDocStringList} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update Content Moderation Info
     * &lt;p&gt;\n\n Admin and Platform specific scope required
     * @param {module:model/AdminModRequest} request Request to update Mod Status
     * @param {module:api/AdminadminportalmodApi~putContentModCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ApiDocStringList}
     */
    this.putContentMod = function(request, callback) {
      var postBody = request;

      // verify the required parameter 'request' is set
      if (request == undefined || request == null) {
        throw "Missing the required parameter 'request' when calling putContentMod";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = [];
      var returnType = ApiDocStringList;

      return this.apiClient.callApi(
        '/admin/admin_portal/mod', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
